"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionErrors = void 0;
var SubscriptionErrors;
(function (SubscriptionErrors) {
    SubscriptionErrors["SubscriptionNotFound"] = "SUBSCRIPTION_NOT_FOUND";
    SubscriptionErrors["SubscriptionAlreadyPresent"] = "SUBSCRIPTION_ALREADY_PRESENT";
})(SubscriptionErrors = exports.SubscriptionErrors || (exports.SubscriptionErrors = {}));
